import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Routes } from 'lib/constants';
import axiosInstance from 'lib/react-query/axios';
import type {
  UserForgotPasswordData,
  VerificationResendResponse,
} from 'types/models/User';

const resendVerification = async (
  email: UserForgotPasswordData['email']
): Promise<VerificationResendResponse> => {
  const { data } = await axiosInstance.post<VerificationResendResponse>(
    Routes.API.RESEND_VERIFICATION,
    { email }
  );

  return data;
};

export const useResendVerification = () =>
  useMutation<
    VerificationResendResponse,
    AxiosError,
    UserForgotPasswordData['email'],
    unknown
  >({
    mutationFn: (email) => resendVerification(email),
  });
